export default __webpack_public_path__ + "static/media/TopQuestion.80ec098d.JPEG";